import type { ComponentProps } from "react"

export type IconCustomObjectBuildingProps = ComponentProps<"svg"> & {
  fill?: string
}
function IconCustomObjectBuilding(props: IconCustomObjectBuildingProps) {
  const { fill = "currentColor", ...svgProps } = props

  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <path
        d="M13.842 4.88194L10.9531 1.27083C10.9531 1.27083 10.9452 1.2665 10.9423 1.26289C10.875 1.18121 10.7905 1.11532 10.6949 1.06989C10.5993 1.02446 10.4949 1.0006 10.3891 1H4.61131C4.503 0.999959 4.39607 1.02428 4.29843 1.07116C4.20079 1.11804 4.11495 1.18628 4.04726 1.27083L1.15837 4.88194C1.05591 5.01007 1.00013 5.16927 1.00021 5.33333L1.00021 14C1.03032 14.4524 1.12581 14.6437 1.62555 14.7222H7.86131H13.278C13.4695 14.7222 13.6532 14.6461 13.7887 14.5107C13.9241 14.3752 14.0002 14.1915 14.0002 14V5.33333C14.0003 5.16927 13.9445 5.01007 13.842 4.88194ZM12.5557 13.2778H8.22242V5.58683L10.3891 2.87777L12.5557 5.5861V13.2778Z"
        fill={fill}
      />
      <path
        d="M9.66685 7.36978H11.1113V8.78914H9.66685V7.36978ZM9.66685 10.2085H11.1113V11.6279H9.66685V10.2085Z"
        fill={fill}
      />
    </svg>
  )
}

export default IconCustomObjectBuilding
